import { AppProps } from '../../App'
import MainWrapper from '../../components/MainWrapper'
import { useTranslation } from 'react-i18next';
import { appName } from '../../utils/constants';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Footer from '../../components/FooterLanding';
import Navbar from '../../components/Navbar';

export const proPlans = [
  { 
    link: process.env.REACT_APP_ENV === 'dev' ? 'https://buy.stripe.com/test_5kAg1eaLwb40cwM9AA' : 'https://buy.stripe.com/bIY5leaZxdGmeC44gk',
    priceId: process.env.REACT_APP_ENV === 'dev' ? 'price_1QntX2IrRy1ZpD68BDRMfjC7' : 'price_1QpBeaIrRy1ZpD688QkOXvnY',
    price: 19,
    duration: '/month',
  },
  { 
    link: process.env.REACT_APP_ENV === 'dev' ? 'https://buy.stripe.com/test_cN22aodXI4FCfIYeUV' : 'https://buy.stripe.com/fZeaFy1oX8m2bpS006',
    priceId: process.env.REACT_APP_ENV === 'dev' ? 'price_1QntcMIrRy1ZpD68vpRaNtv8' : 'price_1QpJZbIrRy1ZpD686f7X6BA7',
    price: 169,
    duration: '/year',
  }
];

const Pricing = (props: AppProps) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [planIndex, setPlanIndex] = useState(0);

  const getPro = () => {
    window.open(`${proPlans[planIndex].link}?prefilled_email=${props.user?.email}`, '_blank');
  }

  return (
    <>
      <div className='flex flex-col'>
        <Navbar {...props} />
        <div className='p-8 py-16 md:p-24 md:py-16'>
          <h1 className='text-4xl md:text-5xl text-center'>{t('pricing.title')}</h1>
          {/* <div className='flex justify-center'>  
            <div className='flex gap-4 items-stretch justify-center mt-8 p-2 rounded-xl border'>
              <button onClick={() => setPlanIndex(0)} className={`animate text-sm flex flex-col items-center justify-center rounded-lg p-2 px-8 ${planIndex === 0 ? 'bg-primary/10' : ''}`}>{t('pricing.monthly')}</button>
              <button onClick={() => setPlanIndex(1)} className={`animate text-sm flex flex-col items-center justify-center rounded-lg p-2 px-8 ${planIndex === 1 ? 'bg-primary/10' : ''}`}>{t('pricing.yearly')}<span className='text-primary'>{t('pricing.save', { percent: 26 })}</span></button>
            </div>
          </div> */}
        </div>
        <div className='flex flex-col md:flex-row justify-center items-center md:items-stretch gap-8 px-8 pt-4 pb-16'>
          {/* free plan */}
          {/* <div className='flex flex-col justify-between w-full md:w-2/5 max-w-sm rounded-xl p-6 md:p-8 border'>
            <div>
              <div className='font-bold text-lg md:text-xl'>{appName} {t('pricing.free')}{props.user?.plan.name === 'free' && <span className='font-light text-sm ml-2'>({t('pricing.your-current-plan')})</span>}</div>
              <div className='my-2'><span className='text-2xl'>US$0</span></div>
              <p className='mt-4 text-sm font-light'>{t('pricing.free-description')}</p>
              {props.user === null && <button onClick={() => navigate('/signin')} className='mt-4 text-sm text-white bg-primary py-2 w-full rounded-lg'>{t('home.get-started')}</button>}
            </div>
            <div className='mt-4'>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.free-limit.apps')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.free-limit.users')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.free-limit.databases')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.free-limit.functions')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.free-limit.databases-space')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.free-limit.storages')}</div>
            </div>
          </div> */}
          {/* premium plan */}
          <div className='flex flex-col justify-between w-full md:w-2/5 max-w-sm rounded-xl p-6 md:p-8 border'>
            <div>
              <div className='font-bold text-lg md:text-xl flex items-center'>{appName} {props.user?.plan.name === 'pro' && <span className='font-light text-sm ml-2'>({t('pricing.your-current-plan')})</span>}</div>
              <div className='my-2'><span className='text-2xl'>US${proPlans[planIndex].price}</span> / {t(proPlans[planIndex].duration)}</div>
              {/* <p className='mt-4 text-sm font-light'>{t('pricing.pro-description')}</p> */}
              {(props.user === null || props.user?.plan.name === 'free') && <button onClick={props.user ? getPro : () => navigate('/signin')} className='mt-4 text-sm text-white bg-primary py-2 w-full rounded-lg'>{t(`pricing.upgrade-pro`)}</button>}
            </div>
            <div className='mt-4'>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.plus')}</div>
              <div className='border-b my-4' />
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.apps')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.users')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.databases')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.functions')}</div>
              <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.databases-space')}</div>
              {/* <div className='mt-2 text-sm'><i className='mr-2 fa-solid fa-check text-primary' />{t('pricing.pro-limit.storages')}</div> */}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Pricing